import React, { useState, useEffect } from 'react';
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import TextField from '@mui/material/TextField';
import DeliveryAddress from "app/components/Address/DeliveryaddressCOD.js";
import AddAddress from "app/components/Address/addaddress.js";
import CustomerSupplier from "app/components/Address/CustomerSupplierAddressCOD.js";
import AccountHolder from "app/components/Address/AccountHolderOrganisationCOD.js";
import { DatePicker, DateTimePicker } from '@mui/lab';
import { darkBlueColor } from 'app/layout/material-dashboard-react';
import CircularProgress from '@mui/material/CircularProgress';
import SuccessCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorCircleIcon from '@mui/icons-material/Error';
import axios from 'axios';

export default function FormCO(props) {

    const [contactName, setContactName] = useState("");
    const [customerRef, setCustomerRef] = useState("");
    const [requiredDate, setRequiredDate] = useState(new Date());
    const [requiredUSDate, setRequiredUSDate] = useState(new Date());
    const [ediReference, setEdiReference] = useState("");
    const [sixDigitReference, setSixDigitReference] = useState("");
    const [bookingSlot, setBookingSlot] = useState("");
    const [containerNumber, setContainerNumber] = useState("");
    const [sealNumber, setSealNumber] = useState("");
    const [bookingReference, setBookingReference] = useState("");
    const [bookingID, setBookingID] = useState("");
    const [circularProgress, setCircularProgress] = useState(false);
    const [successCircle, setSuccessCircle] = useState(false);
    const [errorCircle, setErrorCircle] = useState(false);
    const [bookingReferenceOnBlur, setBookingReferenceOnBlur] = useState(false);

    useEffect(() => {
        loadProps();
    }, [props.CODetails]);

    useEffect(() => {
        if (bookingReferenceOnBlur === true) {
            getBookingReference();
        }
    }, [bookingReferenceOnBlur]);

    function loadProps() {
        if (props !== null) {
            if ('COD' in sessionStorage) {
                if (props.CODetails) {
                    if (props.CODetails.length > 0) {
                        {
                            if (contactName === "") {
                                setContactName(props.CODetails[0].contactName);
                                sessionStorage.setItem("CODContactName", props.CODetails[0].contactName);
                            }
                            if (customerRef === "") {
                                setCustomerRef(props.CODetails[0].customerReference);
                                setRequiredDate(Date.parse(props.CODetails[0].requiredDate + '00:00:00'));
                                setRequiredUSDate(props.CODetails[0].requiredDateUnformatted);
                                sessionStorage.setItem("CODCustomerReference", props.CODetails[0].customerReference)
                                sessionStorage.setItem("CODRequiredDate", props.CODetails[0].requiredDate);
                            }
                            if (ediReference === "") {
                                setEdiReference(props.CODetails[0].ediReference);
                                sessionStorage.setItem("CODEdiReference", props.CODetails[0].ediReference);
                            }
                            if (sixDigitReference === "") {
                                setSixDigitReference(props.CODetails[0].sixDigitReference);
                                sessionStorage.setItem("CODSixDigitReference", props.CODetails[0].sixDigitReference);
                            }
                            if (bookingSlot === "") {
                                setBookingSlot(props.CODetails[0].bookingSlot);
                                sessionStorage.setItem("CODBookingSlot", props.CODetails[0].bookingSlot);
                            }
                            if (containerNumber === "") {
                                setContainerNumber(props.CODetails[0].containerNumber);
                                sessionStorage.setItem("CODContainerNumber", props.CODetails[0].containerNumber);
                            }
                            if (sealNumber === "") {
                                setSealNumber(props.CODetails[0].sealNumber);
                                sessionStorage.setItem("CODSealNumber", props.CODetails[0].sealNumber);
                            }
                            if (bookingReference === "") {
                                setBookingReference(props.CODetails[0].bookingReference);
                                sessionStorage.setItem("CODBookingReference", props.CODetails[0].bookingReference);
                            }
                            if (bookingID === "") {
                                setBookingID(props.CODetails[0].bookingID);
                                sessionStorage.setItem("CODBookingID", props.CODetails[0].bookingID);
                            }
                        }
                    }
                }
            }
        }
    }

    function handleContactChangedValue(value) {
        setContactName(value);
        props.CODetails[0].contactName = value;
        sessionStorage.setItem("CODContactName", value);
    }

    function handleReferenceChangedValue(value) {
        setCustomerRef(value);
        props.CODetails[0].CustomerRef = value;
        sessionStorage.setItem("CODCustomerReference", value);
    }

    const onRequiredDateChange = (date) => {
        setRequiredUSDate(date);
        var dateGB = new Date(date).toLocaleDateString('en-GB');
        setRequiredDate(dateGB);
        props.CODetails[0].requiredDate = dateGB;
        sessionStorage.setItem("CODRequiredDate", dateGB);
    };

    function handleEdiReferenceChangedValue(value) {
        setEdiReference(value);
        props.CODetails[0].ediReference = value;
        sessionStorage.setItem("CODEdiReference", value);
    }

    function handleSixDigitReferenceChangedValue(value) {
        setSixDigitReference(value);
        props.CODetails[0].sixDigitReference = value;
        sessionStorage.setItem("CODSixDigitReference", value);
    }

    const onBookingSlotChange = (date) => {
        var newDate = date !== null ? new Date(date).toLocaleString() : date;
        setBookingSlot(newDate);
        props.CODetails[0].bookingSlot = newDate;
        sessionStorage.setItem("CODBookingSlot", newDate);
    };

    function handleContainerNumberChangedValue(value) {
        setContainerNumber(value);
        props.CODetails[0].containerNumber = value;
        sessionStorage.setItem("CODContainerNumber", value);
    }

    function handleSealNumberChangedValue(value) {
        setSealNumber(value);
        props.CODetails[0].sealNumber = value;
        sessionStorage.setItem("CODSealNumber", value);
    }

    function handleBookingReferenceChangedValue(value) {
        setBookingReference(value);
        setSuccessCircle(false);
        setErrorCircle(false);
    }

    function handleBookingReferenceOnBlur(value) {
        setCircularProgress(true);
        setBookingReferenceOnBlur(true)
        setSuccessCircle(false);
        setErrorCircle(false);
    }

    function getBookingReference() {
        setSuccessCircle(false);
        setErrorCircle(false);
        if (bookingReference) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentByReference`, { params: { shipmentReference: bookingReference } })
                .then((res) => {
                    setCircularProgress(false);
                    setBookingReferenceOnBlur(false);
                    if (res.data.length !== 0) {
                        setBookingReference(bookingReference);
                        props.CODetails[0].bookingReference = bookingReference;
                        sessionStorage.setItem("CODBookingReference", bookingReference);

                        props.CODetails[0].bookingID = res.data[0].shipmentID;
                        sessionStorage.setItem("CODBookingID", res.data[0].shipmentID);

                        setSuccessCircle(true);
                        setTimeout(() => {
                            setSuccessCircle(false)
                        }, 3000)
                        setErrorCircle(false);
                    }
                    else {
                        setSuccessCircle(false);
                        setErrorCircle(true);

                        props.CODetails[0].bookingID = null;
                        sessionStorage.setItem("CODBookingID", null);
                    }
                })
                .catch((e) => {
                    console.log('Booking Details GetShipmentByReference error happened');
                    setSuccessCircle(false);
                    setErrorCircle(true);

                    props.CODetails[0].bookingID = null;
                    sessionStorage.setItem("CODBookingID", null);
                });
        }
        else {
            setCircularProgress(false);
            setBookingReferenceOnBlur(false);

            props.CODetails[0].bookingID = null;
            sessionStorage.setItem("CODBookingID", null);
        }
    }

    return (
        <GridContainer>
            <GridContainer xs={12} sm={12} justifyContent="flex-end">
                <GridItem justifyContent="flex-end">
                <AddAddress buttonColour="blue" sectionColour={darkBlueColor} />
                </GridItem>
            </GridContainer>
            <GridItem xs={12} sm={12}>
                <AccountHolder />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="Contact Name"
                    id="contactName"
                    name="contactName"
                    type="text"
                    value={contactName}
                    onChange={e => handleContactChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    required
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="PO Number"
                    id="customerReference"
                    name="customerReference"
                    type="text"
                    value={customerRef}
                    onChange={e => handleReferenceChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    required
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <div style={{ position: 'relative', width: '100%' }}>
                    <TextField
                        label="Booking Reference"
                        id="bookingReference"
                        name="bookingReference"
                        type="text"
                        value={bookingReference}
                        onChange={e => handleBookingReferenceChangedValue(e.target.value)}
                        onBlur={e => handleBookingReferenceOnBlur(e.target.value)}
                        fullWidth
                        style={{ marginTop: '10px' }}
                        error={errorCircle}
                        size="small"
                    />
                    {circularProgress && (<CircularProgress style={{ position: 'absolute', right: 10, marginTop: 10, color: '#2059A7' }}></CircularProgress>)}
                    {successCircle && (<SuccessCircleIcon style={{ position: 'absolute', right: 10, fontSize: 40, marginTop: 10, color: '#2059A7' }}></SuccessCircleIcon>)}
                    {errorCircle && (<ErrorCircleIcon style={{ position: 'absolute', right: 10, fontSize: 40, marginTop: 10, color: 'red' }}></ErrorCircleIcon>)}
                </div>
            </GridItem>
            <GridItem xs={12} sm={12}>
                <CustomerSupplier />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <DeliveryAddress />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <DatePicker
                    id="requiredDate"
                    name="requiredDate"
                    label="Required Delivery Date"
                    value={requiredUSDate}
                    onChange={onRequiredDateChange}
                    renderInput={(params) => <TextField size="small" required fullWidth sx={{ marginTop: 1 }} {...params} />}
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="EDI Reference"
                    id="ediReference"
                    name="ediReference"
                    type="text"
                    value={ediReference}
                    onChange={e => handleEdiReferenceChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="Six Digit Reference"
                    id="sixDigitReference"
                    name="sixDigitReference"
                    type="text"
                    value={sixDigitReference}
                    onChange={e => handleSixDigitReferenceChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="Container Number"
                    id="containerNumber"
                    name="containerNumber"
                    type="text"
                    value={containerNumber}
                    onChange={e => handleContainerNumberChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <TextField
                    label="Seal Number"
                    id="sealNumber"
                    name="sealNumber"
                    type="text"
                    value={sealNumber}
                    onChange={e => handleSealNumberChangedValue(e.target.value)}
                    fullWidth
                    style={{ marginTop: '10px' }}
                    size="small"
                />
            </GridItem>
            <GridItem xs={12} sm={12}>
                <DateTimePicker
                    id="bookingSlot"
                    name="bookingSlot"
                    label="Booking Slot"
                    value={bookingSlot}
                    onChange={onBookingSlotChange}
                    renderInput={(params) => <TextField size="small" fullWidth sx={{ marginTop: 1 }} {...params} />}
                />
            </GridItem>
        </GridContainer>
    );
}